<div class="empresa-container white-panel" id="empresa" #rootElement>
    <div class="container">
        <h1>Nuestra Historia</h1>
        <div [innerHTML]="historia"></div>
    </div>
</div>